import { render, staticRenderFns } from "./AuthDesc.vue?vue&type=template&id=683c5698"
import script from "./AuthDesc.vue?vue&type=script&lang=js"
export * from "./AuthDesc.vue?vue&type=script&lang=js"
import style0 from "./AuthDesc.vue?vue&type=style&index=0&id=683c5698&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports